<template lang="html">
  <div class="domain-help">
    <Guide
      :content="content"
      width="x-small"
      contentHeading="Manage DNS settings"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'DomainDnsManagement',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'domain-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'domain-login',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'domain-dns-config',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>You'll now need to locate your <strong>DNS Settings</strong> for the specified domain name. The section may be called "Manage DNS Settings", "Modify DNS Records" or similar.</p>
        <p>It may even be under "Advanced domain settings".</p>
        <p>If you're having trouble finding this, you can contact support <strong>of your domain host</strong>.
        </p>
        <p>For your convenience, we've created an email template to help you explain exactly what you need to do. You can send this to the support team of your domain registrar and ask them to do it for you.</p>
        <p><em>The email template is on the next step.</em></p>
      `
    }
  }
}
</script>
